import React from 'react';

type AvatarProps = {
  src?: string | null;
  fallback: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  alt?: string;
};

const sizeMap: Record<NonNullable<AvatarProps['size']>, string> = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base',
  lg: 'h-12 w-12 text-lg',
  xl: 'h-16 w-16 text-xl',
};

const Avatar: React.FC<AvatarProps> = ({ src, fallback, size = 'md', alt }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={alt ?? ''}
        className={`${sizeMap[size]} shrink-0 rounded-full object-cover ring-1 ring-slate-200 dark:ring-gray-700`}
      />
    );
  }
  return (
    <div
      className={`${sizeMap[size]} flex shrink-0 items-center justify-center rounded-full bg-slate-200 font-medium text-slate-700 dark:bg-gray-700 dark:text-slate-200`}
      aria-label={alt ?? fallback}
    >
      {(fallback || '?').charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;
